import React, { ReactElement } from 'react';
import { Card } from '../../../../components/Card/Card';
import { graphql } from '../../../../generated';
import { withSuspendedCard } from '../../../../util/suspense';
import { useSuspenseQuery } from '@apollo/client';
import { t } from '../../../../locales/translate';
import { KeyValueTable } from '../../../../components/KeyValueTable/KeyValueTable';
import { Icon } from '../../../../components/Icon/Icon';
import { useModalPresenter } from '../../../../components/Modal/PresentedModal';
import { UpdateShopModal } from './update_shop_modal';

const ORDER_SHOP_DETAILS = graphql(`
  query GetOrderShopDetails($id: ID!) {
    order(id: $id) {
      id
      permissions {
        id
        update
      }
      shop {
        id
        name
        domain
      }
    }
  }
`);

interface Props {
  orderId: string;
}

function ShopDetails$({ orderId }: Props): ReactElement | null {
  const { data } = useSuspenseQuery(ORDER_SHOP_DETAILS, {
    variables: { id: orderId },
  });

  const shop = data?.order?.shop;
  const permissions = data.order?.permissions;
  const modal = useModalPresenter();

  if (!shop && !permissions?.update) {
    return null;
  }

  return (
    <Card
      title={t.model.order.shopDetails.title}
      actions={
        <>
          <Icon
            name="edit"
            onClick={() => {
              modal.present(UpdateShopModal, { orderId, shopId: shop?.id });
            }}
          ></Icon>
        </>
      }
    >
      <KeyValueTable
        items={[
          { key: t.model.order.shopDetails.shop, value: shop?.name },
          { key: t.model.order.shopDetails.domain, value: shop?.domain },
        ]}
        emptyMsg={t.model.order.shopDetails.noShop}
      />
    </Card>
  );
}

export const ShopDetails = withSuspendedCard(ShopDetails$, {
  loadingTitle: t.model.order.shopDetails.title,
});
